<script>
import App from '@/pages/layouts/app.vue'
import {Link} from "@inertiajs/vue3";
import Card from "@/pages/components/card.vue";
import Form from '@/pages/users/_form.vue'
import Roles from "@/pages/users/roles";
import UpdateForm from "@wielink-application/shared/js/mixins/updateForm";
import Datatable from "@wielink-application/shared/js/mixins/datatable";

export default {
  mixins: [Roles, UpdateForm, Datatable],
  components: {App, Link, Card, Form},
  props: ['userId', 'tableConfig'],

  data() {
    return {
      name: 'Gebruiker',
      user: {},
      formRoute: route('api.v1.users.update', {user: this.userId}),
      redirectRoute: route('users.index')
    }
  },

  mounted() {
    this.getUser();
  },

  methods: {
    afterSuccess(form, response) {
      this.getUser();
    },

    getUser() {
      this.loading = true;
      $.ajax({
        url: route('api.v1.users.show', {user: this.userId}),
        success: (response) => {
          this.name = response.data.name;
          this.user = response.data;
          this.$refs.form.setUser(this.user);
        }
      }).always(() => {
        this.loading = false;
      });
    }
  }
}
</script>

<template>
  <App :title="`${name} bewerken`">
    <form id="userForm" @submit.prevent="submit">
      <Form v-model:user="user" :roles="roles" ref="form" :tableConfig="tableConfig"/>
    </form>

    <Card class="mb-4" v-if="tableConfig">
      <h2 class="card-title">Gekoppelde cilinders</h2>
      <Table ref="table" id="userCylinders" :config="tableConfig"/>
    </Card>

    <template #bottomButtons>
      <FormButtons
          :cancelRoute="redirectRoute"
          @backToOverview="stayOnPage = 0"
          form-id="userForm"
          :loading="loading || loadingRoles"
      />
    </template>
  </App>
</template>